<!--
 * @Author: your name
 * @Date: 2021-04-29 13:09:45
 * @LastEditTime: 2021-04-29 13:24:31
 * @LastEditors: Please set LastEditors
 * @Description: 医生端图片消息
 * @FilePath: /dsicm-admin-web/src/views/treatment/components/messageTypeCompnents/custom-fourteen.vue
-->
<template>
  <div class="custom-14" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      <img
        :src="data.data | assembleImgSrc"
        alt=""
        @click="openDoctorImage(data.data)"
      />
    </div>
    <el-dialog
      :visible="showImgRef"
      :close-on-click-modal="false"
      @close="handleCloseImgRef"
      title="图片"
      width="50%"
      height="100%"
    >
      <div class="look-Entry-pic">
        <div class="preview-imgs">
          <MultipleOptionImg
            ref="instanceImgRef"
            :oneImg="false"
            :key="instanceTimer"
            :loadIndex="1"
            :otherList="otherList"
            :defaultIndex="defaultInstanceIndex"
            @changeInstanceArrow="changeInstanceArrow"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MultipleOptionImg from "@/components/MultipleOptionImg.vue";
export default {
  components: {
    MultipleOptionImg
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: "#F5F5F5"
    },
    color: {
      type: String,
      default: "#333"
    }
  },
  data() {
    return {
      showImgRef: false,
      defaultInstanceIndex: 0,
      instanceTimer: 0,
      otherList: []
    };
  },
  methods: {
    openDoctorImage(e) {
      console.log(e, "e");
      this.otherList = [];
      let obj = {
        url:e
      }
      this.otherList.push(obj);
      this.instanceTimer++;
      this.showImgRef = true;
      this.defaultInstanceIndex = 0;
      // this.$emit("openDoctorImage", e);//已经添加过放大旋转了，所以注释此代码
    },
    handleCloseImgRef() {
      this.showImgRef = false;
    },
    changeInstanceArrow(defaultAddImgIndex) {
      this.defaultInstanceIndex = defaultAddImgIndex;
    }
  }
};
</script>

<style lang="less" scoped>
.custom-14 {
  border-radius: 4px;
  .info-content {
    img {
      // height: 200px;
      width: 200px;
      border-radius: 4px;
    }
  }
}
</style>
